export default __webpack_public_path__ + "img/pin_icons/card_reader_w.png";